'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.DynamicFooterContainerStyles = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  '.keepItTight': {
    alignItems: 'center',
    backgroundColor: 'inherit',
    borderTop: '1px solid lightgray',
    bottom: 0,
    display: 'flex',
    paddingTop: '.5em',
    left: 0,
    right: 0,
    flexDirection: 'column',
    opactiy: '.80',
    height: 50,
    fontFamily: 'TradeGothicLTStd-Cn18',
    justifyContent: 'center',
    gridRowStart: 2,
    gridRowEnd: 3,
    width: '100%'
  },
  '.keepItTight i': {
    cursor: 'pointer',
    textAlign: 'center'
  },
  '& .unAbridgedWarning': {
    display: 'none'
  },
  '.keepItTight p': {
    cursor: 'pointer'
  },
  '& a': {
    textDecoration: 'none',
    color: 'inherit'
  }
};

var DynamicFooterContainerStyles = exports.DynamicFooterContainerStyles = function DynamicFooterContainerStyles(expanded) {
  return expanded ? (0, _assign2.default)({}, defaultStyle, {
    '.keepItTight': (0, _extends3.default)({}, defaultStyle['.keepItTight'], {
      height: 'auto',
      padding: '.5em'
    }),
    '& .unAbridgedWarning': (0, _extends3.default)({}, defaultStyle['& .unAbridgedWarning'], {
      paddingLeft: '5em',
      paddingRight: '5em',
      display: 'flex'
    })
  }) : defaultStyle;
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref) {
  var isExpanded = _ref.isExpanded;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var dynamicStyles = DynamicFooterContainerStyles(isExpanded);

  return (0, _extends3.default)({}, dynamicStyles, (0, _objectResolvePath2.default)(theme, 'Footer.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Footer/Footer.style.js
// module id = 417
// module chunks = 0